<template>
  <div class="home">
    <main class="main-content">
      <b-container fluid="xl" class="section-home">
        <h1>{{$t('home-head-black-1')}}<br>
        <span class="red-text">{{$t('home-head-red-1')}}</span>
        {{$t('home-head-black-2')}}
        <span class="red-text">{{$t('home-head-red-2')}}</span>
        </h1>
        <p>{{$t('home-head-small')}}</p>
        <img class="img-fluid" src="../assets/imgs/home-bg-img.png" alt="compathnion-bg">
        <a href="#footer" class="btn btn-primary"> {{$t('home-contact-btn')}}</a>
      </b-container>

      <b-container fluid="xl" class="section-1">
        <h2 class="section-title">{{$t('section-title-1')}}</h2>
        <h3 class="section-sub-title">{{$t('section-sub-title-1')}}</h3>
        <b-row class="mt-5">
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="shadow" src="../assets/imgs/home-section-1-img-1.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-1-img-1-title')}}</span>
            <p class="image-detail">{{$t('section-1-img-1-p')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="shadow" src="../assets/imgs/home-section-1-img-2.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-1-img-2-title')}}</span>
            <p class="image-detail">{{$t('section-1-img-2-p')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="shadow" src="../assets/imgs/home-section-1-img-3.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-1-img-3-title')}}</span>
            <p class="image-detail">{{$t('section-1-img-3-p')}}</p>
          </b-col>
        </b-row>
      </b-container>

      <!--PC端展示-->
      <b-container v-if="!isMobile" fluid="xl" class="section-2">
        <h2 class="section-title">{{$t('section-title-2')}}</h2>

        <b-row style="margin-top: 60px">
          <b-col>
            <b-img src="../assets/imgs/home-section-2-img-1.png" fluid></b-img>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col class="row-content" style="text-align: left">
            <h5 class="row-title">{{$t('section-2-row-1-title')}}</h5>
            <p class="row-detail" v-html="$t('section-2-row-1-detail')"></p>
          </b-col>
        </b-row>

        <b-row style="margin-top: 120px">
          <b-col class="row-content" style=" text-align: right;">
            <h5 class="row-title">{{$t('section-2-row-2-title')}}</h5>
            <p class="row-detail" v-html="$t('section-2-row-2-detail')"></p>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col>
            <b-img src="../assets/imgs/home-section-2-img-2.png" fluid></b-img>
          </b-col>
        </b-row>

        <b-row style="margin-top: 134px">
          <b-col style="text-align: right">
            <b-img src="../assets/imgs/home-section-2-img-3.png" fluid></b-img>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col class="row-content" style="text-align: left">
            <h5 class="row-title">{{$t('section-2-row-3-title')}}</h5>
            <p class="row-detail" v-html="$t('section-2-row-3-detail')"></p>
          </b-col>
        </b-row>
      </b-container>
      <!--手机端展示-->
      <b-container v-else class="section-2">

        <h2 class="section-title">{{$t('section-title-2')}}</h2>

        <b-row style="margin-top: 60px">
          <b-col cols="12" class="text-center">
            <b-img src="../assets/imgs/home-section-2-img-1.png" style="width: 80%;" fluid></b-img>
          </b-col>
          <b-col class="row-content mt-5" style="text-align: center">
            <h5 class="row-title">{{$t('section-2-row-1-title')}}</h5>
            <p class="row-detail" v-html="$t('section-2-row-1-detail')"></p>
          </b-col>
        </b-row>

        <b-row style="margin-top: 120px">
          <b-col cols="12" class="text-center">
            <b-img src="../assets/imgs/home-section-2-img-2.png" style="width: 80%;" fluid></b-img>
          </b-col>
          <b-col class="row-content mt-5" style=" text-align: center;">
            <h5 class="row-title">{{$t('section-2-row-2-title')}}</h5>
            <p class="row-detail" v-html="$t('section-2-row-2-detail')"></p>
          </b-col>
        </b-row>

        <b-row style="margin-top: 134px">
          <b-col cols="12" class="text-center">
            <b-img src="../assets/imgs/home-section-2-img-3.png" style="width: 80%;" fluid></b-img>
          </b-col>
          <b-col class="row-content mt-5" style="text-align: center">
            <h5 class="row-title">{{$t('section-2-row-3-title')}}</h5>
            <p class="row-detail" v-html="$t('section-2-row-3-detail')"></p>
          </b-col>
        </b-row>

      </b-container>
    </main>
  </div>
</template>

<script>
import runtime from '../utils/runtime'

export default {
  name: 'Home',
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  }
}
</script>
<style lang="scss" scoped>
  .home {
    .main-content {
      padding-bottom: 100px;

      .section-home {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 10% 25%;
        height: 35rem;
        overflow: hidden;
        max-width: unset;
        background: radial-gradient(ellipse, #FFFFFF 20%, transparent);
        box-shadow: 2px 2px 2px #A9A9A9;

        h1 {
          position: relative;
          z-index: 1;
          font-size: 3rem;
          font-weight: 700;
          color: #000000;
        }

        h1 .red-text {
          color: #EE350D;
        }

        p {
          position: relative;
          z-index: 1;
          font-size: 1.5rem;
          color: #808080;
          font-wight: 150;
          margin-top: 1rem;
        }

        img {
          z-index: -1;
          position: absolute;
          top: 0;
          left: 0;
          min-width: 100%;
          height: 100%;
        }

        .btn {
          z-index: 1;
          width: 10rem;
          color: #000000;
          border-color: #000000;
          box-shadow: 2px 2px 2px #A9A9A9;
        }
      }

      .section-title {
        height: 4rem;
        line-height: 4rem;
        font-size: 34px;
        font-weight: 700;
        color: #000000;
        background: linear-gradient(90deg, #BEBEBE, #FFFFFF);
      }

      .section-sub-title {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        line-height: 1.4;
        margin-top: 16px;
      }

      .image-title {
        display: block;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        margin-top: 24px;
      }
      .image-detail {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 20px;
        margin-top: 24px;
      }

      .section-1{
        margin-top: 3rem;
      }

      .section-2{
        margin-top: 5rem;

        .row-content {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          .row-title {
            font-size: 24px;
            font-weight: 700;
            color: #000000;
          }

          .row-detail {
            font-size: 18px;
            font-weight: 400;
            color: #000000;
            line-height: 1.4;
            margin-top: 31px;
          }
        }
      }
    }

  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .row-title {
      font-size: 20px !important;
    }
    .row-detail {
      font-size: 16px !important;
      margin-top: 10px !important;
    }

    .section-home {
      padding: 15% 15% !important;
      height: 25rem !important;
      background: radial-gradient(ellipse, #FFFFFF 35%, transparent) !important;

      h1 {
        font-size: 2rem !important;
      }
      p {
        font-size: 1rem !important;
      }
      img {
        height: 100%;
        object-fit: cover;
      }
    }

    .section-title {
      font-size: 20px !important;
      text-align: center;
    }
    .section-sub-title {
      font-size: 12px !important;
      text-align: center;
    }
    .image-title {
      font-size: 14px !important;
      margin-top: 24px;
    }
    .image-detail {
      font-size: 12px !important;
      margin-top: 24px;
    }
  }
</style>
